module.exports = __webpack_public_path__ + "img/assurPlus_mobile.eda8643a.jpg";